import { destroy, get, post } from '@/utils/fetch'
import type { TProjectPublicInfo } from '@/interfaces/project'
import type { TProjectInviteListItem, TProjectInvitePublicInfo } from '@/interfaces/project-invite'

export const getProjectInviteList = async (projectId: string) => {
  const result = await get<TProjectInviteListItem[]>(
    `/project/invite/list?projectId=${projectId}`,
  )
  return result
}

export const removeProjectInvite = async (id: string) => {
  const result = await destroy<{ result: TProjectInvitePublicInfo }>(
    `/project/invite?id=${id}`,
  )
  return result
}

export const getPendingProjectInvite = async () => {
  const result = await get<{ invite: TProjectInvitePublicInfo | null }>(
    '/project/invite/pending',
  )
  return result
}

export const createProjectInvite = async (data: {
  projectId: string
  email: string
}) => {
  const result = await post<
    { result: TProjectInvitePublicInfo } | { inviteNotSentReason: string }
  >('/project/invite', data)
  return result
}

export const getProjectInviteById = async (id: string) => {
  const invite = await get<TProjectInvitePublicInfo>(
    `/project/invite?id=${id}`,
  )
  return invite
}

export const acceptProjectInvite = async (id: string) => {
  const result = await post<
    { result: TProjectPublicInfo, projectId: string } | { acceptFailureReason: string }
  >('/project/invite/accept', { id })
  return result
}
